import { render, staticRenderFns } from "./CaraPage.vue?vue&type=template&id=39072748&scoped=true&lang=pug"
import script from "./CaraPage.vue?vue&type=script&lang=js"
export * from "./CaraPage.vue?vue&type=script&lang=js"
import style0 from "./CaraPage.vue?vue&type=style&index=0&id=39072748&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39072748",
  null
  
)

export default component.exports